<template>
  <wdw-dynbox :title="domainStore.translate('user.profile.menu-item.delete')">
    <Form @submit="onSubmitDeleteForm">
      <div id="wdw-delete-form" class="wdw-form">
        <p>
          {{ domainStore.translate('user.profile.delete.info-one') }}
          <br />
          {{ domainStore.translate('user.profile.delete.info-two') }}
        </p>
        <button class="btn btn-danger btn-form-delete" type="submit" name="submit" :disabled="data.loading">
          {{ domainStore.translate('user.profile.delete.submit') }}
        </button>
        &nbsp;
        <button
          type="button"
          class="btn btn-default btn-form-cancel"
          :disabled="data.loading"
          name="cancel"
          @click="emitClose()"
        >
          {{ domainStore.translate('user.form.cancel') }}
        </button>
        <vue-loading v-if="data.loading" />
      </div>
    </Form>
  </wdw-dynbox>
</template>

<script>
import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';
import useConverter from '@/composables/general/useConverter';
import { onMounted, reactive, computed, ref } from 'vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { RepositoryFactory } from '@/api/repositoryFactory';

import { Form } from 'vee-validate';
import VueLoading from '@/components/general/Loading';

const UserRepository = RepositoryFactory.get('user');
const DomainRepository = RepositoryFactory.get('domain');

export default {
  name: 'request-delete',

  props: {},
  emits: ['close'],

  setup(props, context) {
    const data = reactive({
      //show loading view
      loading: false,
    });
    const { toBool } = useConverter();

    //+---------------------+
    //|   computed          |
    //+---------------------+

    const user = computed(() => {
      return userStore.getState().user;
    });

    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });

    //+--------------------+
    //|    Methods         |
    //+--------------------+

    function emitClose(message) {
      context.emit('close', message);
    }
    const onSubmitDeleteForm = (values, actions) => {
      data.loading = true;

      values['confirm'] = true;
      UserRepository.putDelete(user.value.id, values)
        .then(resp => {
          data.loading = false;
          emitClose(domainStore.translate('user.profile.delete.success'));
        })
        .catch(err => {
          console.log(err);
          data.loading = false;
        });
    };

    return {
      // ---VARIABLE---
      domainStore,
      // Computed methods

      // Listeners
      onSubmitDeleteForm,
      emitClose,

      // Other
      data,
    };
  },

  components: {
    WdwDynbox,
    Form,
    VueLoading,
  },
};
</script>
